import { CUSTOMERSHOW } from "@/config/api";
import { VISITOR_COOKIE_NAME } from "@/config/constConf";
import { getCookieItem } from "@/lib/commonService";
import { isObject } from "../utils";
import { HandleJavaCommonFetch, HandlePhpFetch } from "@/src/utils/fetch";
const backendUrl = "front/user/browse/add";
export function getVistorId() {
    let cookieData;
    try {
        let jsonData = getCookieItem(VISITOR_COOKIE_NAME);

        if (jsonData) {
            cookieData = JSON.parse(jsonData);
        }
    } catch (e) {
        console.error("getVistorId", e);
    }
    const visitor_id = cookieData ? cookieData.visitor_id : "";
    return visitor_id;
}

export const getCustomerShow = (params: number | Record<string, any>) => {
    return HandlePhpFetch.get(CUSTOMERSHOW, {
        params: isObject(params) ? { limit: params } : params,
    });
};
